import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandSeparator'
})
export class ThousandSeparatorPipe implements PipeTransform {

  transform(value: number | string): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    // Konversi input ke string jika belum berbentuk string
    const stringValue = typeof value === 'number' ? value.toString() : value;

    // Memisahkan bagian desimal jika ada
    const parts = stringValue.split('.');

    // Format bagian integer dengan titik sebagai pemisah ribuan
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Menggabungkan kembali dengan bagian desimal (jika ada)
    return parts.join(',');
  }

}
